(function () {
  var acknowledged = false

  function unblockCtas() {
    var blocker = document.getElementById('cart-ctas-blocker')
    if (blocker) blocker.remove()

    var wrapper = document.getElementById('cart-ctas-wrapper')
    if (wrapper) {
      wrapper.classList.remove('cart__ctas--blocked')
      wrapper.style.opacity = ''
    }

    var checkoutBtn = document.getElementById('checkout')
    if (checkoutBtn) checkoutBtn.disabled = false
  }

  function blockCtas() {
    var wrapper = document.getElementById('cart-ctas-wrapper')
    if (!wrapper) return

    if (!document.getElementById('cart-ctas-blocker')) {
      var blocker = document.createElement('div')
      blocker.className = 'cart__ctas-blocker'
      blocker.id = 'cart-ctas-blocker'
      wrapper.insertBefore(blocker, wrapper.firstChild)
    }

    wrapper.classList.add('cart__ctas--blocked')
    wrapper.style.opacity = '0.4'

    var checkoutBtn = document.getElementById('checkout')
    if (checkoutBtn) checkoutBtn.disabled = true
  }

  // Checkbox toggle → block or unblock
  // Uses event delegation so it survives morphSection re-renders
  document.addEventListener('change', function (event) {
    if (event.target.id !== 'final-sale-inline-ack') return
    if (event.target.checked) {
      acknowledged = true
      unblockCtas()
    } else {
      acknowledged = false
      blockCtas()
    }
  })

  // After cart AJAX updates (morphSection), the blocker is re-injected by the template.
  // If the customer already acknowledged, auto-unblock and re-check the checkbox.
  var _observer = new MutationObserver(function () {
    if (!acknowledged) return
    var blocker = document.getElementById('cart-ctas-blocker')
    if (blocker) {
      unblockCtas()
      var checkbox = document.getElementById('final-sale-inline-ack')
      if (checkbox) checkbox.checked = true
    }
  })
  _observer.observe(document.body, { childList: true, subtree: true })
})()
